export const formatCurrency = (
  value?: number,
  currency = "USD",
  digitsFormat: "long" | "short" = "short",
) => {
  const safe = typeof value === "number" ? value : 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    ...(digitsFormat === "long"
      ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
      : { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
  }).format(safe);
};
